import styled from 'styled-components';

export default styled.div`
	display: flex;
	flex-direction: column;
	gap: var(--spacing-x-large);
	flex: 1;
	min-height: 0;
`;
